<template>
  <v-app class="profile-app">
    <v-container :fluid="isMobile" class="elegant-container">
      <v-row justify="center">
        <v-col cols="12" md="10" lg="8">
          <h2 class="elegant-title text-center">프로필 관리</h2>
          <div class="text-subtitle-1 text-secondary font-weight-medium text-center mb-6">
            Profile Management
          </div>
          
          <CardAccount
                :selected-account-id="user.accountId"
                class="profile-account-card"
              />
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import apiAccount from "@/api/modules/api-account";
import CardAccount from "@/components/Card/CardAccount";

export default {
  data() {
    return {
      idExist: false,
      idNotExist: false,
      kakaoAppKey: process.env.VUE_APP_KAKAO_OAUTH2_CLIENT_KEY,
      params: {
        client_id: process.env.VUE_APP_GOOGLE_OAUTH2_CLIENT_KEY
      },
    }
  },
  components: {CardAccount},
  computed: {
    ...mapGetters(['user', 'isStudent', 'isTeacher', 'isMobile']),
  },
  created() {},
  mounted() {},
  methods: {
    ...mapActions(['fetchUser', 'updateUser', 'saveAccountInfo', 'saveAccountProfileImage']),
    async loginOAuth2() {
      // OAuth2 login logic
    },
    onGoogleLoginSuccess(accountSns) {
      let userInfo = []
      userInfo.push('sub', accountSns.getBasicProfile().getId())
      userInfo.push('name', accountSns.getBasicProfile().getName())
      userInfo.push('email', accountSns.getBasicProfile().getEmail())
      userInfo.push('picture', accountSns.getBasicProfile().getImageUrl())

      apiAccount.saveAccountSns('google', userInfo)
    },
    onGoogleLoginFailure(accountSns) {
      console.log(accountSns)
    },
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/elegant-theme.scss";

.profile-app {
  background-color: v-bind("$vuetify.theme.dark ? '#121212' : '#f8f9fa'") !important;
  min-height: 100vh;
}

.profile-card {
  border-radius: 12px !important;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  background-color: v-bind("$vuetify.theme.dark ? '#1E1E1E' : '#ffffff'") !important;
  border: v-bind("$vuetify.theme.dark ? '1px solid #333' : 'none'");
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: v-bind("$vuetify.theme.dark ? '0 8px 30px rgba(0, 0, 0, 0.3)' : '0 8px 30px rgba(0, 0, 0, 0.1)'") !important;
  }
}

.profile-header {
  padding: 16px 20px !important;
  background: v-bind("$vuetify.theme.dark ? 'rgba(63, 81, 181, 0.1)' : 'linear-gradient(to right, rgba(63, 81, 181, 0.05), rgba(63, 81, 181, 0.1))'");
  border-bottom: v-bind("$vuetify.theme.dark ? '1px solid #333' : '1px solid rgba(0, 0, 0, 0.05)'");
  
  .text-h6 {
    color: v-bind("$vuetify.theme.dark ? '#fff' : '#424242'");
    font-weight: 600;
  }
}

.profile-content {
  background-color: v-bind("$vuetify.theme.dark ? '#1E1E1E' : '#ffffff'");
  padding: 20px !important;
}

.profile-account-card {
  :deep(.v-text-field--outlined) {
    border-radius: 8px;
    margin-top: 8px !important;
    margin-bottom: 8px !important;
    
    .v-input__slot {
      min-height: 44px;
      border: v-bind("$vuetify.theme.dark ? '1px solid #333' : '1px solid #e0e0e0'") !important;
      background-color: v-bind("$vuetify.theme.dark ? '#2d2d2d' : '#ffffff'") !important;
    }
    
    fieldset {
      border-color: transparent !important;
    }
  }
  
  :deep(.v-btn) {
    text-transform: none;
    letter-spacing: 0.5px;
    font-weight: 600;
    height: 38px;
    
    &.primary {
      background-color: #3f51b5 !important;
      
      &:hover {
        background-color: darken(#3f51b5, 5%) !important;
      }
    }
  }
}

.elegant-container {
  padding: 16px !important;
  
  @media (min-width: 960px) {
    padding: 24px !important;
    max-width: 1200px;
  }
}

.elegant-title {
  margin-bottom: 0.5rem !important;
}

.text-subtitle-1 {
  margin-bottom: 1.5rem !important;
}
</style>

